import ProjectsOverview from './components/pages/ProjectsOverview';
import {
  createHashRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from 'react-router-dom';
import Sitemap from './components/pages/Sitemap';
import ProjectView from './components/pages/ProjectView';
import Header from './components/molecules/Header';
import Footer from './components/molecules/Footer';
import { possibleBaseUrls } from './store/baseUrl/baseUrlStore.types';

const Routing: () => JSX.Element = () => {
  const router = createHashRouter([
    {
      element: (
        <>
          <Header />
          <main id="main-content-wrapper" className="main-content-wrapper">
            <Outlet />
          </main>
          <Footer />
        </>
      ),
      children: [
        {
          path: '/',
          element: <Navigate to={possibleBaseUrls[0].path} />,
        },
        {
          path: '/:base/',
          element: <ProjectsOverview />,
        },
        {
          path: '/:base/sitemap',
          element: <Sitemap />,
        },
        {
          path: '/:base/detail/:projectId',
          element: <ProjectView />,
        },
      ],
    },
  ]);

  return (
    <div id="all">
      <RouterProvider router={router} />
    </div>
  );
};

export default Routing;
